import Currency from '@v2/shared/components/Currency';
import { useSite } from '@v2/shared/lib/site';
import { Magazine } from './types';

type Props = {
  magazines: Magazine[];
};

/**
 * The wall of covers.
 *
 * The cards are not links, as they were not at the source: these are Magzter's titles,
 * and a good part of the catalogue is not on our site at all — a link that sometimes goes
 * nowhere is worse than a card that never pretends to.
 *
 * The struck-through price is what that title costs on its own at Magzter, which is the
 * comparison the page exists to make. It renders in the site's own currency, matching the
 * landing page's featured wall; both are Magzter's USD figures, which is the behaviour
 * headless_jshop shipped and is not something this migration changes.
 */
export default function MagazineGrid({ magazines }: Props) {
  const { currency } = useSite();

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
      {magazines.map((magazine) => (
        <div key={magazine.id}>
          <div className="border-2 border-slate-100 rounded-lg h-52 sm:h-60 md:h-64 lg:h-72 w-full overflow-hidden mb-2">
            <img src={magazine.image} alt={magazine.name} loading="lazy" className="w-full h-full" />
          </div>
          <div className="font-semibold">{magazine.name}</div>
          {!!magazine.list_price && magazine.list_price > 0 && (
            <div className="line-through font-medium tracking-tight text-slate-400">
              <Currency value={magazine.list_price} currencyCode={currency} />
              /year
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
